import { OrderStatistics } from '@api/shipping-data/types/OrderStatistics';
import OrderRow from '@pages/orders/detail/tabs-pages/basic-overview/orders/OrderRow';



interface OrdersProps {
	orders: OrderStatistics[],
	selectedOrderUnvId: string | null,
	scrollToOrderGrid: (orderUnvId: string) => void,
}


export const Orders = (props: OrdersProps) => {
	const { orders, selectedOrderUnvId, scrollToOrderGrid } = props;

	return (
		<div className='detail-orders'>
			
			<p>Obj:</p>
			
			<div className='detail-orders-list'>
				{orders.map(x =>
					<OrderRow
						orderStatistics={x}
						isSelectedOrder={x.unversionedSystemId ? x.unversionedSystemId === selectedOrderUnvId : false}
						scrollToOrderGrid={scrollToOrderGrid}
						key={`detail-orders-list-item-${x.systemId}`} />)}
			</div>
		
		</div>
	)
}

export default Orders;